import httpUtils from "../utils/http-utils";
import { API_PATH } from "../config/app-config";

const analyticsApi = {
  summary: (days = 30) => httpUtils.get(`${API_PATH.ANALYTICS}/summary?days=${days}`),
  history: (days = 30) => httpUtils.get(`${API_PATH.ANALYTICS}/history?days=${days}`),
};

export default analyticsApi;
